module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1517-09428c10d6b8c9b5ff6f88307599a3b3.png";